import Plyr from "plyr";
import stylesheet from 'plyr/dist/plyr.css';

const initVideo = () => {
  const videos = document.querySelectorAll('.video');

  if (videos.length < 1) return;
  stylesheet;

  const controls = [
    'play-large',
    'play',
    'progress',
    'current-time',
    'mute', 'volume',
    'captions',
    'settings',
    'pip',
    'airplay',
    'fullscreen',
  ];

  videos.forEach(video => {
    const videoPlayer = video.querySelector('.section-video-js');
    const placeholder = video.querySelector('.video__placeholder');
    const videoBtn = video.querySelector('.video__btn');

    if (videoPlayer) {
    const player =  new Plyr(videoPlayer, {
        autoplay: false,
        muted: false,
        controls,
        youtube: {
          showinfo: 0,
          disablekb: 1,
          loop: 0,
          modestbranding: 0,
          playlist: video.dataset.plyrEmbedId,
        },
        vimeo: {
          loop: false,
          autoplay: false,
        },
      });

      player.on('ready', () => {
        const wrapper = player.elements.container;
        wrapper.setAttribute('inert', '');
        wrapper.setAttribute('aria-hidden', 'true');
      });

      videoBtn.addEventListener('click', () => {
        placeholder.style.opacity = 0;
        player.play();
        setTimeout(() => {
          placeholder.remove();
          player.elements.container.removeAttribute('tabindex');
          player.elements.container.removeAttribute('inert');
        }, 300);
      })
    }
  })
}

window.addEventListener('load', () => {
  initVideo();
});
